import axios from "axios";
import errorHandler from "./errorHandler";
import { getClerkInstance } from "@/init/clerk";

const url = process.env.VUE_APP_EG_API_URL;

const api = axios.create({
  withCredentials: "include",
  baseURL: url,
});

// successHandler just returns normal response from server
const successHandler = (res) => res;

api.interceptors.response.use(successHandler, errorHandler);
api.interceptors.request.use(async (config) => {
  const token = await getClerkInstance()?.session?.getToken();

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }

  return config;
});
export default api;
